export default "__VITE_ASSET__9ca29ada__"